var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2862 2.47009C24.2862 2.47009 16.3162 4.5801 16.3162 22.0401",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2861 2.47009C24.2861 2.47009 32.2561 4.5801 32.2561 22.0401",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2861 0.300049V2.47005",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.376221 22.0401C4.78622 19.1401 11.9162 19.1401 16.3162 22.0401C20.7262 19.1401 27.8562 19.1401 32.2562 22.0401C36.6662 19.1401 43.7962 19.1401 48.1962 22.0401C48.1962 11.2301 37.4862 2.47009 24.2862 2.47009C11.0862 2.47009 0.376221 11.2301 0.376221 22.0401Z",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7661 45.95V47.04C17.7661 48.84 19.2261 50.3 21.0261 50.3C22.8261 50.3 24.2861 48.84 24.2861 47.04V19.87",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.43,
    height: 50.6,
    fill: "white",
    transform: "translate(0.0761719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.0313fc5b7a92faacdb7880ce8ec0caaf.svg";
export { ForwardRef as ReactComponent };